import { createContext } from 'common/ui/util';
import type { CreateContextReturn } from 'common/ui/util';

export type UnifiedEditorElementContextValue = {
  element: HTMLElement | null;
  setElement: (node: HTMLElement | null) => void;
};

export const [
  UnifiedEditorElementProvider,
  useUnifiedEditorElementContext,
  UnifiedEditorElementContext,
]: CreateContextReturn<Nullable<UnifiedEditorElementContextValue>> = createContext<
  Nullable<UnifiedEditorElementContextValue>
>({
  name: 'unified-editor-element',
  strict: false,
  defaultValue: null,
});

export const useUnifiedEditorElement = (): HTMLElement | null =>
  useUnifiedEditorElementContext()?.element ?? null;

export const useSetUnifiedEditorElement = (): ((node: HTMLElement | null) => void) => {
  const context = useUnifiedEditorElementContext();
  return context?.setElement ?? (() => {});
};
